<template>
    <div class="legend-container">
        <div class="legend-title">
            <div class="legend-color" :style="{background: item.color}"></div>

            <div class="legend-name">
                <!-- <el-badge :value="item.notRead" :max="99" :hidden="hasNotRead"> -->
                    <div class="legend-text">
                        {{item.name}}
                                        </div>
                <!-- </el-badge> -->
            </div>
        </div>
        <div class="legend-value">
            {{item.num}}
        </div>
    </div>
</template>

<script>

export default {
    props: {
        item: Object,
    },
    computed: {
        // hasNotRead: function () {
        //     return this.item.notRead === 0;
        // },
        // notRead: function () {
        //     return this.item.notRead;
        // }
    }
}
</script>

<style lang="less" scoped>
.legend-container {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    min-height: 100%;

    .legend-title {
        display: flex;
        justify-content: center;
        align-items: center;

        .legend-color {
            width: 16rem;
            height: 16rem;
        }

        .legend-name {
            margin-left: 7px;

            .legend-text {
                font-size: 18rem;
                font-weight: 400;
                color: #666666;
            }
        }
    }

    .legend-value {            
        font-size: 24rem;
        font-weight: bold;
        color: #333333;
    }
}
</style>